import React, { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import AnnotationPopover from 'chameleon/packages/blue-book-player/Annotation/AnnotationPopover';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import useFirstLoad from 'chameleon/packages/blue-book-player/hooks/useFirstLoad';
import { SELECTORS } from 'chameleon/packages/blue-book-player/constants/selectors';
import { constrainVerticalWithinContainer } from 'chameleon/packages/blue-book-player/Annotation/utils/constrainVerticalWithinContainer';
import { BluebookContext } from '../state/BluebookContext';

const AnnotationInit = (props) => {
  const { learnosityApp, learnosityItemReference, isStudentAccount, subject } =
    props;
  const { state: playerState } = useContext(BluebookContext);
  const playerEl = useGetPlayerEl();
  const [learnosityAnnotationContainer, setLearnosityAnnotationContainer] =
    useState(null);
  const [annotationsApp, setAnnotationsApp] = useState(null);

  useFirstLoad(playerState, () => {
    const annotationContainer = playerEl?.querySelector(
      SELECTORS.ANNOTATION_POPOVER_CONTAINER,
    );

    setLearnosityAnnotationContainer(annotationContainer);
    const learnosityAnnotationsApp = learnosityApp
      ?.assessApp()
      ?.annotationsApp();
    setAnnotationsApp(learnosityAnnotationsApp);
    learnosityAnnotationsApp
      ?.module('texthighlight')
      ?.utils?.setBlackListIds?.(['MathJax-']);
  });

  if (!playerEl) {
    return null;
  }
  if (!learnosityAnnotationContainer) {
    return null;
  }
  const innerContainer = document.querySelector(
    '.bluebook-player-inner-container',
  );
  constrainVerticalWithinContainer(
    learnosityAnnotationContainer,
    innerContainer,
  );

  return createPortal(
    <AnnotationPopover
      annotationsApp={annotationsApp}
      learnosityApp={learnosityApp}
      learnosityItemReference={learnosityItemReference}
      isStudentAccount={isStudentAccount}
      subject={subject}
    />,
    learnosityAnnotationContainer,
  );
};

export default AnnotationInit;
